import Vue from "vue"
import axios from 'axios'
import router from '../router'
import { Loading } from 'element-ui'


axios.defaults.baseURL = '/api'  // 反向代理URL

Vue.prototype.$http = {};

Vue.prototype.$http.axios = axios.create({
    transformResponse: [function (data) {
        return data;
    }],
    headers: { 'Content-Type': 'application/json;charset=utf-8' }
});

Vue.prototype.$http.post = function ([url, params, ...params2], [okcallback, ercallback], loadingTarget) {
    let loadingInstance = null;

    if (loadingTarget != "none") {
        loadingInstance = Loading.service({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            fullscreen: loadingTarget ? false : true,
            target: loadingTarget
        });
    }

    if (params2) { // 合并请求对象属性
        for (var i in params2) {
            for (var j in params2[i]) {
                params[j] = params2[i][j];
            }
        }
    }

    this.axios.post(url, params).then(function (response) {
        if (loadingInstance != null) {
            loadingInstance.close();
        }

        let data = response.data ? JSON.parse(response.data) : {};

        if (!data.code || data.code != 200) {
            let msg = data.msg;

            if (data.code == 500) {
                msg = '操作失败';
            } else if (data.code == 888) {
                msg = '未登陆';

                ercallback = function () {
                    window.setTimeout(function () {
                        router.push('/login');
                    }, 500);
                }
            }

            Vue.prototype.$message({
                message: msg,
                type: data.code == 500 ? 'error' : 'warning'
            });

            if (ercallback && typeof ercallback == 'function') {
                ercallback(data.code, data.msg);
            }
        } else {
            if (okcallback && typeof okcallback == 'function') {
                okcallback(data.data, function(okmsg) {
                    Vue.prototype.$message({
                        message: okmsg ? okmsg : "操作成功",
                        type: 'success'
                    });
                });
            }
        }
    }, function () {

        Vue.prototype.$message({
            message: '服务器错误',
            type: 'error'
        });

        if (loadingInstance != null) {
            loadingInstance.close();
        }
    });
}






